/* eslint-disable import/no-extraneous-dependencies */

import Admin from '../../components/Admin';

import getFilterWithCol from '../../helpers/getFilterWithCol';

const isNotButton = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'BUTTON',
]);

export default [
  getFilterWithCol(['FieldText', {
    name: 'button_link',
    label: null,
    prefix: 'Link:',
  }], 12),
  getFilterWithCol(['FieldText', {
    name: 'button_label',
    label: null,
    prefix: 'Label:',
    i18nTranslatable: true,
  }], 12),
  getFilterWithCol(['FieldRadio', {
    name: 'button_align',
    label: null,
    initialValue: 'left',
    choices: [
      { value: 'left', label: 'Align Left' },
      { value: 'center', label: 'Align Center' },
      { value: 'right', label: 'Align Right' },
    ],
    block: true,
  }], 24),
].map(([fieldType, fieldConfig]) => Admin.compileFromLibrary([
  fieldType,
  { ...fieldConfig, skip: [isNotButton, ...(fieldConfig.skip || [])] },
]));
